(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-complementary-products"] && !Shopify.designMode) return;
  try {
    
  const productRecommendationsSection = document.querySelector('#complementary-products');

  if (productRecommendationsSection) {
    const url = productRecommendationsSection.dataset.url;
    fetchRecommendations(url);
  }

  function fetchRecommendations(url) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#complementary-products');
        const productItems = recommendations.querySelectorAll('.product-grid-item');

        if (recommendations && recommendations.innerHTML.trim().length && productItems.length > 0) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          productRecommendationsSection.classList.remove('hidden');
        } else {
          productRecommendationsSection.classList.add('hidden');
        }
      })
      .catch((e) => {
        console.error(e);
        productRecommendationsSection.classList.add('hidden');
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-recommended-products"] && !Shopify.designMode) return;
  try {
    
  const productRecommendationsSection = document.querySelector('#recommended-products');
  if (productRecommendationsSection) {
    const url = productRecommendationsSection.dataset.url;
    fetchRecommendations(url);
  }

  function fetchRecommendations(url) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#recommended-products');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  } catch(e) { console.error(e); }
})();
})();
